import dayjs from 'dayjs';

const svrMinRate = 0.035;

const getSwitchStatus = ({
  fixedRate,
  productEndDate,
  fixedRateEndDate,
  interestRate,
  fromDate,
}) => {
  const today = fromDate || new Date();

  const endDate = productEndDate || fixedRateEndDate;

  const monthsRemaining = endDate
    ? dayjs(endDate).diff(dayjs(today), 'month')
    : 0;

  if (fixedRate !== 'yes') {
    // Could be SVR
    if (interestRate < svrMinRate) {
      return { label: 'unknown', monthsRemaining };
    }
    // Highly likely to be SVR
    return { label: 'now', monthsRemaining, svr: true };
  }

  if (endDate) {
    if (monthsRemaining < 0) {
      // Highly likely to be SVR
      return { label: 'now', monthsRemaining, svr: true };
    }
    // READY TO SWITCH
    if (monthsRemaining <= 4) {
      return { label: 'now', monthsRemaining };
    }

    // SWITCH SOON
    if (monthsRemaining <= 7) {
      return { label: 'soon', monthsRemaining };
    }

    // SWITCH LATER
    if (monthsRemaining > 7) {
      return { label: 'future', monthsRemaining };
    }
  }

  // DEFAULT RETURN UNKNOWN
  return { label: 'unknown', monthsRemaining: 0 };
};

export default getSwitchStatus;
